import React, { useState } from 'react';
import {
  Warehouse, Plus, ArrowRight, ShieldCheck, User, Package,
  Search, Factory,
} from 'lucide-react';
import {
  entrepots, mouvementsStock, tracabilite,
  formatDateTime,
} from '../data/mockData';

const tabs = [
  { id: 'entrepots', label: 'Entrepots' },
  { id: 'mouvements', label: 'Mouvements' },
  { id: 'tracabilite', label: 'Tracabilite equipements' },
];

const Stocks = () => {
  const [active, setActive] = useState('entrepots');
  const [search, setSearch] = useState('');

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Stocks & Entrepots</h1>
          <p className="page-subtitle">Gestion multi-entrepots, mouvements equipements et chaine de tracabilite complete</p>
        </div>
        <button className="btn-primary">
          <Plus size={16} /> Nouveau mouvement
        </button>
      </div>

      <div className="tabs">
        {tabs.map((t) => (
          <button
            key={t.id}
            className={`tab ${active === t.id ? 'active' : ''}`}
            onClick={() => setActive(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="toolbar">
        <div className="search-input grow">
          <Search size={16} />
          <input
            placeholder="Rechercher..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {active === 'entrepots' && (
        <div className="grid-3">
          {entrepots.map((ent) => {
            const pct = Math.round((ent.nbEquipements / ent.capacite) * 100);
            return (
              <div key={ent.id} className="card">
                <header className="card-header">
                  <div className="card-title">
                    <Warehouse size={18} />
                    <h2>{ent.nom}</h2>
                  </div>
                  <span className="mono meta-id">{ent.id}</span>
                </header>
                <div className="card-body">
                  <p className="meta-line">{ent.adresse}</p>
                  <div className="info-grid" style={{ marginTop: '0.75rem' }}>
                    <div>
                      <span className="info-label"><User size={12} /> Responsable</span>
                      <span className="info-value">{ent.responsable}</span>
                    </div>
                    <div>
                      <span className="info-label"><Package size={12} /> Stock</span>
                      <span className="info-value">{ent.nbEquipements} / {ent.capacite}</span>
                    </div>
                  </div>
                  <div className="progress" style={{ marginTop: '0.75rem' }}>
                    <div className="progress-bar" style={{ width: `${pct}%` }} />
                  </div>
                  <span className="meta-line">{pct}% d occupation</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {active === 'mouvements' && (
        <div className="card">
          <div className="card-body">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Mouvement</th>
                  <th>Equipement</th>
                  <th style={{ textAlign: 'right' }}>Qte</th>
                  <th>Origine</th>
                  <th></th>
                  <th>Destination</th>
                  <th>Date / Heure</th>
                  <th>Utilisateur</th>
                  <th>Commentaire</th>
                </tr>
              </thead>
              <tbody>
                {mouvementsStock
                  .filter((m) =>
                    m.equipement.toLowerCase().includes(search.toLowerCase()) ||
                    m.origine.toLowerCase().includes(search.toLowerCase()) ||
                    m.destination.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((m) => (
                    <tr key={m.id}>
                      <td><span className="mono">{m.id}</span></td>
                      <td>{m.equipement}</td>
                      <td style={{ textAlign: 'right' }}>{m.quantite}</td>
                      <td>{m.origine}</td>
                      <td><ArrowRight size={14} className="arrow-muted" /></td>
                      <td>{m.destination}</td>
                      <td>{formatDateTime(m.date)}</td>
                      <td>{m.utilisateur}</td>
                      <td>{m.commentaire}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {active === 'tracabilite' && (
        <div className="card">
          <header className="card-header">
            <div className="card-title">
              <ShieldCheck size={18} />
              <h2>Chaine de tracabilite : Commande - Fournisseur - BL - N serie - Chantier</h2>
            </div>
          </header>
          <div className="card-body">
            <table className="data-table">
              <thead>
                <tr>
                  <th>N serie</th>
                  <th>Equipement</th>
                  <th>Commande</th>
                  <th>Fournisseur</th>
                  <th>BL</th>
                  <th>Chantier</th>
                  <th>Etape</th>
                  <th>Reserves</th>
                </tr>
              </thead>
              <tbody>
                {tracabilite
                  .filter((t) =>
                    t.numeroSerie.toLowerCase().includes(search.toLowerCase()) ||
                    t.equipement.toLowerCase().includes(search.toLowerCase()) ||
                    t.chantier.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((t) => (
                    <tr key={t.numeroSerie}>
                      <td><span className="mono">{t.numeroSerie}</span></td>
                      <td>{t.equipement}</td>
                      <td><span className="mono">{t.commande}</span></td>
                      <td><Factory size={12} className="arrow-muted" /> {t.fournisseur}</td>
                      <td><span className="mono">{t.bl}</span></td>
                      <td>{t.chantier}</td>
                      <td><span className={`badge badge-${t.etape === 'Installe' ? 'ok' : 'info'}`}>{t.etape}</span></td>
                      <td>{t.reserves}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Stocks;
